/* eslint-disable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useMemo } from 'react';
import type { JSX, PropsWithChildren } from 'react';

import type { Translations } from '@change-corgi/core/i18n';
import {
	createUtilityContextI18n,
	__internal_useUtilityContext as useUtilityContext,
	__internal_UtilityContext as UtilityContext,
} from '@change-corgi/core/react/utilityContext';

import { generateAdditionalPlurals } from './generateAdditionalPlurals';

type Props = {
	translations: Translations | readonly Translations[];
};

export function I18nOverrides({ translations, children }: PropsWithChildren<Props>): JSX.Element {
	const utilityContext = useUtilityContext();

	const newUtilityContext = useMemo(() => {
		// adding missing plurals by reusing the .other plural, to avoid missing translations
		// in locales using different plural keys
		const allTranslations: readonly Translations[] = [
			...(Array.isArray(translations) ? translations : [translations]),
			generateAdditionalPlurals(translations),
		];

		const i18n = utilityContext.__internal_originalUtilities.i18n.extends({
			additionalTranslations: allTranslations,
		});
		return {
			...utilityContext,
			i18n: createUtilityContextI18n(i18n),
			__internal_originalUtilities: {
				...utilityContext.__internal_originalUtilities,
				i18n,
			},
		};
	}, [utilityContext, translations]);

	return <UtilityContext.Provider value={newUtilityContext}>{children}</UtilityContext.Provider>;
}
